import { render, staticRenderFns } from "./VerifyEmailUI.vue?vue&type=template&id=9fa7eb94&scoped=true"
import script from "./VerifyEmailUI.vue?vue&type=script&lang=js"
export * from "./VerifyEmailUI.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailUI.vue?vue&type=style&index=0&id=9fa7eb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa7eb94",
  null
  
)

export default component.exports